import CheckboxQuestion from './CheckboxQuestion';
import DropdownQuestion from './DropdownQuestion';
import EmailQuestion from './EmailQuestion';
import FileQuestion from './FileQuestion';
import LongQuestion from './LongQuestion';
import MultiSelectQuestion from './MultiSelectQuestion';
import NumberQuestion from './NumberQuestion';
import ShortQuestion from './ShortQuestion';
import WysiwygQuestion from './WysiwygQuestion';

export default {
    CheckboxQuestion,
    DropdownQuestion,
    EmailQuestion,
    FileQuestion,
    LongQuestion,
    MultiSelectQuestion,
    NumberQuestion,
    ShortQuestion,
    WysiwygQuestion
};
